import { render, staticRenderFns } from "./DomainsList.vue?vue&type=template&id=55a22ef4"
import script from "./DomainsList.vue?vue&type=script&lang=js"
export * from "./DomainsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports